import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSelectMultipleWrapper, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModelWithSource } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

interface Props {
    label: string;
    input: InputModelWithSource;
    allowClear?: boolean;
    message?: string;
    onChange?: () => void;
}

const GenericSelectMultiple: InputWithMeta<Props> = ({ label, input, allowClear = true, message, onChange }) => {
    return (
        <CustomFormItem name={input.guid} required={input.required} message={message} isReadOnly={input.isReadOnly}>
            <CustomSelectMultipleWrapper
                input={input}
                label={label}
                options={input.sourceProvider.options}
                topRightNode={<InputControls input={input} />}
                allowClear={allowClear}
                onChange={onChange}
            />
        </CustomFormItem>
    );
};

GenericSelectMultiple.meta = {
    inputType: InputModelWithSource.name
};

export default observer(GenericSelectMultiple);
